'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  ::placeholder {\n    font-size: ', ';\n  }\n'], ['\n  ::placeholder {\n    font-size: ', ';\n  }\n']);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIMedia = require('UIComponents/layout/UIMedia');

var _UIMedia2 = _interopRequireDefault(_UIMedia);

var _UIMediaBody = require('UIComponents/layout/UIMediaBody');

var _UIMediaBody2 = _interopRequireDefault(_UIMediaBody);

var _UIMediaRight = require('UIComponents/layout/UIMediaRight');

var _UIMediaRight2 = _interopRequireDefault(_UIMediaRight);

var _UITextInput = require('UIComponents/input/UITextInput');

var _UITextInput2 = _interopRequireDefault(_UITextInput);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UILoadingButton = require('UIComponents/button/UILoadingButton');

var _UILoadingButton2 = _interopRequireDefault(_UILoadingButton);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PLACEHOLDER_LENGTH_FONT_SIZE_CUTOFF = 20;

var StyledTextInput = (0, _styledComponents2.default)(_UITextInput2.default).withConfig({
  displayName: 'EmailCaptureInput__StyledTextInput'
})(_templateObject, function (_ref) {
  var placeholder = _ref.placeholder;
  return placeholder.length > PLACEHOLDER_LENGTH_FONT_SIZE_CUTOFF ? '14px' : undefined;
});

var propTypes = {
  buttonColor: _react.PropTypes.string.isRequired,
  email: _react.PropTypes.string,
  error: _react.PropTypes.bool,
  locale: _react.PropTypes.string,
  onChange: _react.PropTypes.func.isRequired,
  onKeyPress: _react.PropTypes.func.isRequired,
  onSubmit: _react.PropTypes.func.isRequired,
  submitting: _react.PropTypes.bool.isRequired
};

var EmailCaptureInput = function EmailCaptureInput(_ref2) {
  var buttonColor = _ref2.buttonColor,
      email = _ref2.email,
      error = _ref2.error,
      onChange = _ref2.onChange,
      onKeyPress = _ref2.onKeyPress,
      onSubmit = _ref2.onSubmit,
      submitting = _ref2.submitting,
      locale = _ref2.locale;

  var buttonStyle = {
    backgroundColor: submitting ? undefined : buttonColor,
    borderColor: submitting ? undefined : buttonColor
  };

  return _react2.default.createElement(
    _UIMedia2.default,
    { className: 'email-capture-input-container' },
    _react2.default.createElement(
      _UIMediaBody2.default,
      { className: 'display-flex align-center' },
      _react2.default.createElement(StyledTextInput, {
        styled: false,
        value: email,
        placeholder: _I18n2.default.text('conversationsUI.emailCapture.placeholderText', { locale: locale }),
        onChange: onChange,
        onKeyPress: onKeyPress
      })
    ),
    _react2.default.createElement(
      _UIMediaRight2.default,
      null,
      _react2.default.createElement(
        _UILoadingButton2.default,
        {
          className: 'email-capture-submit-button',
          disabled: submitting,
          failed: error,
          style: buttonStyle,
          onClick: onSubmit,
          loading: submitting,
          use: submitting ? 'tertiary-light' : 'primary-white',
          color: _colors.OLAF,
          spinnerProps: {
            style: { width: '100%', height: '100%' }
          },
          resultIcon: 'success'
        },
        _react2.default.createElement(_UIIcon2.default, { color: _colors.OLAF, name: 'send' })
      )
    )
  );
};

EmailCaptureInput.propTypes = propTypes;

exports.default = EmailCaptureInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/emailCapture/EmailCaptureInput.js
// module id = 1107
// module chunks = 2 3